// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: white;
  margin: 0;
  font-family: 'Rubik', sans-serif;
}

.navigation-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background: white;
  backdrop-filter: blur(0px);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  box-sizing: border-box;
  z-index: 1000;
  transition: background 0.3s ease;
}

.navigation-bar.scrolled {
  background: white;
  backdrop-filter: blur(10px);
}

.nav-logo {
  height: 60px;
}

.nav-logo-img {
  max-width: 100%;
  max-height: 100%;
}

.auth-buttons {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 20px;
}

.nav-button {
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  border: 2px solid white;
  color: white;
}

.login-btn {
  background: none;
  color: black;
  border: 2px solid #333;
}

.login-btn:hover {
  background-color: #A5D6A7;
  color: white;
}

.signup-btn {
  background-color: #007bff;
  border: none;
}

.signup-btn:hover {
  background-color: #004D40;
}


@media (max-width: 768px) {
  .navigation-bar {
    padding: 10px 16px;
    height: 65px;
  }

  .nav-logo {
    height: 42px;
  }

  .auth-buttons {
    display: flex;
    flex-direction: row;   
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    margin-left: auto;
  }

  .nav-button {
    padding: 7px 14px;
    font-size: 14px;
    border-radius: 18px;
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/HomeNavBar.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap');\n\nbody {\n  background-color: white;\n  margin: 0;\n  font-family: 'Rubik', sans-serif;\n}\n\n.navigation-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  background: white;\n  backdrop-filter: blur(0px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 70px;\n  box-sizing: border-box;\n  z-index: 1000;\n  transition: background 0.3s ease;\n}\n\n.navigation-bar.scrolled {\n  background: white;\n  backdrop-filter: blur(10px);\n}\n\n.nav-logo {\n  height: 60px;\n}\n\n.nav-logo-img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.auth-buttons {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-left: 20px;\n}\n\n.nav-button {\n  padding: 8px 15px;\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: bold;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  text-align: center;\n  border: 2px solid white;\n  color: white;\n}\n\n.login-btn {\n  background: none;\n  color: black;\n  border: 2px solid #333;\n}\n\n.login-btn:hover {\n  background-color: #A5D6A7;\n  color: white;\n}\n\n.signup-btn {\n  background-color: #007bff;\n  border: none;\n}\n\n.signup-btn:hover {\n  background-color: #004D40;\n}\n\n\n@media (max-width: 768px) {\n  .navigation-bar {\n    padding: 10px 16px;\n    height: 65px;\n  }\n\n  .nav-logo {\n    height: 42px;\n  }\n\n  .auth-buttons {\n    display: flex;\n    flex-direction: row;   \n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-left: auto;\n  }\n\n  .nav-button {\n    padding: 7px 14px;\n    font-size: 14px;\n    border-radius: 18px;\n    white-space: nowrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
